import React from "react";
import { HelpCircle } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

// Small, page-level "Was ist das?" helper. Independent of the guided tour.
// `id` is used for a stable data-testid, `title`/`text` describe the current page.
export const PageHelp = ({ id, title, text }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        data-testid={`page-help-${id}`}
        title="Was ist das?"
        aria-label="Was ist das?"
        className="inline-flex items-center gap-1 text-slate-400 hover:text-primary transition-colors"
      >
        <HelpCircle className="h-5 w-5" />
        <span className="hidden sm:inline text-xs font-medium">Was ist das?</span>
      </button>
    </PopoverTrigger>
    <PopoverContent align="start" className="w-80" data-testid={`page-help-content-${id}`}>
      <div className="flex items-start gap-2">
        <div className="h-8 w-8 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
          <HelpCircle className="h-4 w-4 text-primary" />
        </div>
        <div>
          <h4 className="font-head font-bold text-slate-900 text-sm leading-tight mb-1">{title}</h4>
          <p className="text-sm text-slate-600 leading-relaxed">{text}</p>
        </div>
      </div>
    </PopoverContent>
  </Popover>
);

export default PageHelp;
